/*
 * View for the touchPoint select module
 */

define(["marionette", "messaging/messenger", "./template/touchPointSelectTemplate.html"], function (
  Marionette,
  Messenger,
  touchPointSelectTemplate,
) {
  var TouchPointSelectView = {};

  TouchPointSelectView.touchPointSelectView = Marionette.ItemView.extend({
    className: "row-fluid",
    //Note that on the template, _.each(items) will go through each item in the collection
    //we are given automatically.  Gnarly!
    template: touchPointSelectTemplate,
    events: {
      //This will handle changing which touchPoint is selected.  We use JQuery to figure out the ID of the touchPoint
      //whose drop-down entry was selected
      "change #selectTouchPoint": function () {
        var touchPointId = parseInt(this.$el.find("#selectTouchPoint option:selected").val(), 10);
        this.trigger("touchPoint:changed", touchPointId);
      },
      "mousedown #selectTouchPoint": function () {
        if (!Messenger.reqres.request("save:textbox")) {
          return false; //stop the event from executing and opening the dropdown
        }
      },
    },
  });

  return TouchPointSelectView;
});
